export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6912.ee7930f5.jpg";